import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import {
  buildComplianceResultsListPath,
  parseComplianceResultsList,
} from "./parseComplianceResult";
import type { ComplianceResultsList } from "./types";

export const COMPLIANCE_RESULTS_LIST_QUERY_KEY = [
  "regulator-portal",
  "compliance-results",
] as const;

export const complianceResultsListQueryKey = (cursor?: string) =>
  [...COMPLIANCE_RESULTS_LIST_QUERY_KEY, cursor ?? ""] as const;

export const fetchComplianceResultsList = async (
  cursor?: string,
): Promise<ComplianceResultsList> => {
  const response = await createRegulatorPortalInstance().get(
    buildComplianceResultsListPath(
      API_ROUTES.REGULATOR_COMPLIANCE_RESULTS,
      cursor,
    ),
  );
  return parseComplianceResultsList(response.data);
};

export const useComplianceResultsList = (
  cursor?: string,
): UseQueryResult<ComplianceResultsList, Error> =>
  useQuery<ComplianceResultsList, Error>({
    queryKey: complianceResultsListQueryKey(cursor),
    queryFn: () => fetchComplianceResultsList(cursor),
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: false,
  });
